<template>
  <section class="submit-request">
    <h1 class="fn-title-1">Заявка на кредит</h1>
    <CreditFormNew/>
  </section>
</template>

<script>
import CreditFormNew from '@/components/credit-form/CreditFormNew'

export default {
  components: {
    CreditFormNew
  },
  data: function () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.submit-request {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  min-height: 90vh;

  .fn-title-1 {
    margin: 0 0 40px 0;
  }
}
</style>
